import { useTranslation } from 'react-i18next';
import MultiSelectField, {
  MultiSelectFieldProps,
} from 'components/forms/multiSelectField/MultiSelectField';
import { orderBy } from 'utils/arrayUtils';
import { EVENT_TYPE_OPTIONS } from '../../TriggersTab.constants';

interface EventTypeMultiSelectFieldProps
  extends Omit<MultiSelectFieldProps, 'fieldRenderer' | 'options'> {}

const EventTypeMultiSelectField = ({
  ...props
}: EventTypeMultiSelectFieldProps) => {
  const { t } = useTranslation();
  const events = EVENT_TYPE_OPTIONS.map((value) => ({
    label: t('pageAutomations.triggers.eventType', { context: value }),
    value,
  }));
  const options = orderBy(events, [{ field: 'label', order: 'asc' }]);

  return (
    <MultiSelectField
      colSmInput={8}
      colSmLabel={4}
      isSelectAllEnabled
      label={t('pageAutomations.triggers.filters.eventType')}
      options={options}
      {...props}
    />
  );
};

export default EventTypeMultiSelectField;
